module.exports = __webpack_public_path__ + "static/media/manastir.cdccf08b.jpg";